
import { defineAsyncComponent, defineComponent } from 'vue';

export default defineComponent({
  name: 'student-home-route',
  components: {
    theHeader: defineAsyncComponent(() => import('./herder/index.vue')),
  },
  props: {},
  setup() {
    return {
    };
  },
});
